import { useState } from "react";
import { testIds } from "@/testIds";
import { TIKZ_TEMPLATES, type TikzTemplate } from "@/lib/tikzTemplates";
import { describePrompt } from "@/lib/tikzAuthoring";
import { prefillAsk } from "@/lib/askPrefill";
import styles from "./TikzSplitView.module.scss";

const T = testIds.tikzSplit;

/**
 * The starter templates (1b): the split view's empty state, and the header's
 * Templates popover. Six cards, then "Describe it instead", which only fills
 * Ask Lilia's input — nothing is sent until the author sends it.
 */
export function TikzTemplates({ compact = false, onPick }: { compact?: boolean; onPick: (t: TikzTemplate) => void }) {
  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);
  const send = () => {
    if (!text.trim()) return;
    prefillAsk(describePrompt(text));
    setSent(true);
  };
  return (
    <div className={compact ? styles.galleryCompact : styles.gallery}>
      {!compact && (
        <div className={styles.galleryHead}>
          <span className={styles.galleryTitle}>Start a TikZ figure</span>
          <span className={styles.galleryLede}>Pick a starting point, or describe it to Ask Lilia.</span>
        </div>
      )}
      <div className={styles.cards}>
        {TIKZ_TEMPLATES.map((t) => (
          <button
            key={t.id}
            type="button"
            className={styles.card}
            data-testid={T.template}
            data-template={t.id}
            onClick={() => onPick(t)}
          >
            <span className={styles.cardThumb} style={{ backgroundImage: `url("${t.thumb}")` }} aria-hidden="true" />
            <span className={styles.cardBody}>
              <span className={styles.cardName}>{t.name}</span>
              {!compact && <span className={styles.cardDesc}>{t.desc}</span>}
              <span className={styles.cardLibs}>{t.libs}</span>
            </span>
          </button>
        ))}
      </div>
      <div className={styles.describe}>
        <label className={styles.describeLabel} htmlFor="tikz-describe-input">
          Describe it instead
        </label>
        <input
          id="tikz-describe-input"
          data-testid={T.describe}
          className={styles.describeInput}
          value={text}
          placeholder="e.g. a flowchart of the review process with three decisions"
          onChange={(e) => {
            setText(e.target.value);
            setSent(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              send();
            }
          }}
        />
        <button type="button" className={styles.describeSend} data-testid={T.describeSend} disabled={!text.trim()} onClick={send}>
          {sent ? "In Ask Lilia" : "goes to Ask Lilia"}
        </button>
      </div>
    </div>
  );
}
